var React = require('react');

function IconNewWindow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#ff6300;}")),React.createElement("polygon",{"className":"cls-1","points":"8.5 14 2 14 2 2 8.5 2 8.5 3.44 10.5 3.44 10.5 0 0 0 0 16 10.5 16 10.5 12.56 8.5 12.56 8.5 14","key":1}),React.createElement("polygon",{"className":"cls-1","points":"11.78 4.29 10.37 5.71 11.66 7 6.29 7 6.29 9 11.66 9 10.37 10.29 11.78 11.71 15.49 8 11.78 4.29","key":2})]);
}

IconNewWindow.defaultProps = {"width":"16px","height":"16px","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 16 16"};

module.exports = IconNewWindow;

IconNewWindow.default = IconNewWindow;
